/* eslint-disable */
import * as Types from '../../../../../../generated/graphql'

import { gql } from '@apollo/client'
import { PhotosFragmentDoc } from './Photos'
import { TravelAtlasFragmentDoc } from './TravelAtlas'
import { VipFragmentDoc } from './Vip'
import { DatingFragmentDoc } from './Dating'
import { InterestsFragmentDoc } from './Interests'
import { GiftsFragmentDoc } from './Gifts'
import { TeamoTestFragmentDoc } from './Teamo'
export type GQLForeignParamsFragment = {
  __typename?: 'Query'
  user?: {
    __typename?: 'PublicProfile'
    id: any
    name: string
    age?: number | null
    gender: Types.GQLGender
    zodiacSign?: Types.GQLZodiacSign | null
    isBirthdayToday?: boolean | null
    incognito: boolean
    deleted: boolean
    compatibility?: number
    online?: { __typename?: 'Online'; status: boolean } | null
    location: {
      __typename?: 'Location'
      name: string
      city: { __typename?: 'City'; id: string; name: string }
      region: { __typename?: 'Region'; id: string; name: string }
      country: { __typename?: 'Country'; id: string; name: string }
    }
    verification: { __typename?: 'Verification'; verifiedPhotos: boolean }
    relations: {
      __typename?: 'ProfileRelations'
      winkedByMe?: boolean
      contact?: {
        __typename?: 'ChatContact'
        contactId: any
        favorite: boolean
        ignoredByThem: boolean
      } | null
      spaceTimeLocation?: {
        __typename?: 'SpaceTimeLocationRelation'
        text: any
      } | null
      distance?: { __typename?: 'Distance'; text: any } | null
    }
    photos: {
      __typename?: 'ProfilePhotos'
      photosCount: number
      photos: {
        __typename?: 'PublicPhotosConnection'
        nodes: Array<{
          __typename?: 'Photo'
          main: boolean
          width: number
          height: number
          portrait: boolean
          verified: boolean
          voted: boolean
          voteable: boolean
          likes: number
          liked: boolean
          photoId: any
          urls: {
            __typename?: 'PhotoUrls'
            huge: string
            square: string
            squareLarge: string
            squareSmall: string
            xHuge?: string | null
          }
          faceCenter?: {
            __typename?: 'PhotoFaceCenter'
            xHuge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
            huge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
          } | null
        }>
        pageInfo: {
          __typename?: 'PageInfo'
          hasNextPage: boolean
          endCursor: any
        }
      }
      default?: {
        __typename?: 'Photo'
        main: boolean
        width: number
        height: number
        portrait: boolean
        verified: boolean
        voted: boolean
        voteable: boolean
        likes: number
        liked: boolean
        photoId: any
        urls: {
          __typename?: 'PhotoUrls'
          huge: string
          square: string
          squareLarge: string
          squareSmall: string
          xHuge?: string | null
        }
        faceCenter?: {
          __typename?: 'PhotoFaceCenter'
          xHuge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
          huge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
        } | null
      } | null
    }
    travelAtlas: {
      __typename?: 'PublicTravelAtlas'
      visitedCountries: {
        __typename?: 'PublicTravelAtlasVisitedCountries'
        visitedCountriesCount: number
        visitedCountries: {
          __typename?: 'PublicTravelAtlasVisitedCountriesConnection'
          nodes: Array<{
            __typename?: 'PublicTravelAtlasVisitedCountry'
            date: string
            country: {
              __typename?: 'Country'
              id: string
              name: string
              code: string
              isoCode: string
            }
          }>
          pageInfo: {
            __typename?: 'PageInfo'
            hasNextPage: boolean
            endCursor: any
          }
        }
      }
      badges: {
        __typename?: 'PublicTravelAtlasBadges'
        badgesCount: number
        badges: {
          __typename?: 'PublicTravelAtlasBadgesConnection'
          nodes: Array<{
            __typename?: 'PublicTravelAtlasBadge'
            id: number
            name: string
            desc: string
            image: string
          }>
          pageInfo: {
            __typename?: 'PageInfo'
            hasNextPage: boolean
            endCursor: any
          }
        }
      }
    }
    vip: {
      __typename?: 'Vip'
      active: boolean
      presentVip?: {
        __typename?: 'PublicPresentVip'
        days: number
        hidden: boolean
        presenter?: {
          __typename?: 'PublicProfile'
          id: any
          name: string
          gender: Types.GQLGender
          age?: number | null
          online?: {
            __typename?: 'Online'
            status: boolean
            description: any
          } | null
          verification: { __typename?: 'Verification'; verifiedPhotos: boolean }
          location: { __typename?: 'Location'; name: string }
          photos: {
            __typename?: 'ProfilePhotos'
            default?: {
              __typename?: 'Photo'
              id: any
              urls: {
                __typename?: 'PhotoUrls'
                squareSmall: string
                square: string
                squareLarge: string
                huge: string
              }
            } | null
          }
        } | null
      } | null
    }
    dating: {
      __typename?: 'PublicDatingProfile'
      aboutMe: string
      lookFor: Array<Types.GQLLookFor>
      datingGoals?: Array<Types.GQLDatingGoals> | null
      knownLanguages?: Array<any> | null
      height?: number | null
      weight?: number | null
      orientation?: Types.GQLOrientation | null
      children?: Types.GQLChildren | null
      education?: Types.GQLEducation | null
      appearance?: Types.GQLAppearance | null
      constitution?: Types.GQLConstitution | null
      alcohol?: Types.GQLAlcoholAttitude | null
      smoking?: Types.GQLSmokingAttitude | null
      homeStatus?: Types.GQLHomeStatus | null
      materialStatus?: Types.GQLMaterialStatus | null
      lookForAge: { __typename?: 'AgeRange'; from: number; to: number }
    }
    sharing?: {
      __typename?: 'PublicSharing'
      widgets?: {
        __typename?: 'PublicWidgets'
        thisIsMe?: { __typename?: 'ThisIsMeWidget'; url: string } | null
      } | null
    } | null
    interests: {
      __typename?: 'PublicInterests'
      interestsCount: number
      interests: {
        __typename?: 'PublicInterestsConnection'
        nodes: Array<{
          __typename?: 'PublicInterest'
          interestId: number
          text: string
          matchMy?: boolean | null
        }>
        pageInfo: {
          __typename?: 'PageInfo'
          hasNextPage: boolean
          endCursor: any
        }
      }
    }
    gifts: {
      __typename?: 'Gifts'
      giftsCount: number
      gifts: {
        __typename?: 'GiftsConnection'
        nodes: Array<{
          __typename?: 'Gift'
          giftId: number
          message: string
          senderHidden: boolean
          my: boolean
          senderProfile?: {
            __typename?: 'PublicProfile'
            id: any
            name: string
            age?: number | null
            gender: Types.GQLGender
            deleted: boolean
            photos: {
              __typename?: 'ProfilePhotos'
              default?: {
                __typename?: 'Photo'
                id: any
                urls: { __typename?: 'PhotoUrls'; square: string }
              } | null
            }
            online?: { __typename?: 'Online'; status: boolean } | null
            relations: {
              __typename?: 'ProfileRelations'
              spaceTimeLocation?: {
                __typename?: 'SpaceTimeLocationRelation'
                text: any
              } | null
            }
            verification: {
              __typename?: 'Verification'
              verifiedPhotos: boolean
            }
          } | null
          image: {
            __typename?: 'MyGiftImage'
            name: string
            formats: Array<number>
          }
        }>
        pageInfo: {
          __typename?: 'PageInfo'
          endCursor: any
          hasNextPage: boolean
        }
      }
    }
    teamo?: {
      __typename?: 'PublicTeamo'
      compatibility?: number | null
      surveyResult?: Array<{
        __typename?: 'TeamoPeculiarity'
        id: number
        points: number
        title: string
        description: string
      }> | null
    } | null
  } | null
}

export type GQLForeignProfileFragment = {
  __typename?: 'PublicProfile'
  id: any
  name: string
  age?: number | null
  gender: Types.GQLGender
  zodiacSign?: Types.GQLZodiacSign | null
  isBirthdayToday?: boolean | null
  incognito: boolean
  deleted: boolean
  compatibility?: number
  online?: { __typename?: 'Online'; status: boolean } | null
  location: {
    __typename?: 'Location'
    name: string
    city: { __typename?: 'City'; id: string; name: string }
    region: { __typename?: 'Region'; id: string; name: string }
    country: { __typename?: 'Country'; id: string; name: string }
  }
  verification: { __typename?: 'Verification'; verifiedPhotos: boolean }
  relations: {
    __typename?: 'ProfileRelations'
    winkedByMe?: boolean
    contact?: {
      __typename?: 'ChatContact'
      contactId: any
      favorite: boolean
      ignoredByThem: boolean
    } | null
    spaceTimeLocation?: {
      __typename?: 'SpaceTimeLocationRelation'
      text: any
    } | null
    distance?: { __typename?: 'Distance'; text: any } | null
  }
  photos: {
    __typename?: 'ProfilePhotos'
    photosCount: number
    photos: {
      __typename?: 'PublicPhotosConnection'
      nodes: Array<{
        __typename?: 'Photo'
        main: boolean
        width: number
        height: number
        portrait: boolean
        verified: boolean
        voted: boolean
        voteable: boolean
        likes: number
        liked: boolean
        photoId: any
        urls: {
          __typename?: 'PhotoUrls'
          huge: string
          square: string
          squareLarge: string
          squareSmall: string
          xHuge?: string | null
        }
        faceCenter?: {
          __typename?: 'PhotoFaceCenter'
          xHuge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
          huge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
        } | null
      }>
      pageInfo: {
        __typename?: 'PageInfo'
        hasNextPage: boolean
        endCursor: any
      }
    }
    default?: {
      __typename?: 'Photo'
      main: boolean
      width: number
      height: number
      portrait: boolean
      verified: boolean
      voted: boolean
      voteable: boolean
      likes: number
      liked: boolean
      photoId: any
      urls: {
        __typename?: 'PhotoUrls'
        huge: string
        square: string
        squareLarge: string
        squareSmall: string
        xHuge?: string | null
      }
      faceCenter?: {
        __typename?: 'PhotoFaceCenter'
        xHuge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
        huge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
      } | null
    } | null
  }
  travelAtlas: {
    __typename?: 'PublicTravelAtlas'
    visitedCountries: {
      __typename?: 'PublicTravelAtlasVisitedCountries'
      visitedCountriesCount: number
      visitedCountries: {
        __typename?: 'PublicTravelAtlasVisitedCountriesConnection'
        nodes: Array<{
          __typename?: 'PublicTravelAtlasVisitedCountry'
          date: string
          country: {
            __typename?: 'Country'
            id: string
            name: string
            code: string
            isoCode: string
          }
        }>
        pageInfo: {
          __typename?: 'PageInfo'
          hasNextPage: boolean
          endCursor: any
        }
      }
    }
    badges: {
      __typename?: 'PublicTravelAtlasBadges'
      badgesCount: number
      badges: {
        __typename?: 'PublicTravelAtlasBadgesConnection'
        nodes: Array<{
          __typename?: 'PublicTravelAtlasBadge'
          id: number
          name: string
          desc: string
          image: string
        }>
        pageInfo: {
          __typename?: 'PageInfo'
          hasNextPage: boolean
          endCursor: any
        }
      }
    }
  }
  vip: {
    __typename?: 'Vip'
    active: boolean
    presentVip?: {
      __typename?: 'PublicPresentVip'
      days: number
      hidden: boolean
      presenter?: {
        __typename?: 'PublicProfile'
        id: any
        name: string
        gender: Types.GQLGender
        age?: number | null
        online?: {
          __typename?: 'Online'
          status: boolean
          description: any
        } | null
        verification: { __typename?: 'Verification'; verifiedPhotos: boolean }
        location: { __typename?: 'Location'; name: string }
        photos: {
          __typename?: 'ProfilePhotos'
          default?: {
            __typename?: 'Photo'
            id: any
            urls: {
              __typename?: 'PhotoUrls'
              squareSmall: string
              square: string
              squareLarge: string
              huge: string
            }
          } | null
        }
      } | null
    } | null
  }
  dating: {
    __typename?: 'PublicDatingProfile'
    aboutMe: string
    lookFor: Array<Types.GQLLookFor>
    datingGoals?: Array<Types.GQLDatingGoals> | null
    knownLanguages?: Array<any> | null
    height?: number | null
    weight?: number | null
    orientation?: Types.GQLOrientation | null
    children?: Types.GQLChildren | null
    education?: Types.GQLEducation | null
    appearance?: Types.GQLAppearance | null
    constitution?: Types.GQLConstitution | null
    alcohol?: Types.GQLAlcoholAttitude | null
    smoking?: Types.GQLSmokingAttitude | null
    homeStatus?: Types.GQLHomeStatus | null
    materialStatus?: Types.GQLMaterialStatus | null
    lookForAge: { __typename?: 'AgeRange'; from: number; to: number }
  }
  sharing?: {
    __typename?: 'PublicSharing'
    widgets?: {
      __typename?: 'PublicWidgets'
      thisIsMe?: { __typename?: 'ThisIsMeWidget'; url: string } | null
    } | null
  } | null
  interests: {
    __typename?: 'PublicInterests'
    interestsCount: number
    interests: {
      __typename?: 'PublicInterestsConnection'
      nodes: Array<{
        __typename?: 'PublicInterest'
        interestId: number
        text: string
        matchMy?: boolean | null
      }>
      pageInfo: {
        __typename?: 'PageInfo'
        hasNextPage: boolean
        endCursor: any
      }
    }
  }
  gifts: {
    __typename?: 'Gifts'
    giftsCount: number
    gifts: {
      __typename?: 'GiftsConnection'
      nodes: Array<{
        __typename?: 'Gift'
        giftId: number
        message: string
        senderHidden: boolean
        my: boolean
        senderProfile?: {
          __typename?: 'PublicProfile'
          id: any
          name: string
          age?: number | null
          gender: Types.GQLGender
          deleted: boolean
          photos: {
            __typename?: 'ProfilePhotos'
            default?: {
              __typename?: 'Photo'
              id: any
              urls: { __typename?: 'PhotoUrls'; square: string }
            } | null
          }
          online?: { __typename?: 'Online'; status: boolean } | null
          relations: {
            __typename?: 'ProfileRelations'
            spaceTimeLocation?: {
              __typename?: 'SpaceTimeLocationRelation'
              text: any
            } | null
          }
          verification: { __typename?: 'Verification'; verifiedPhotos: boolean }
        } | null
        image: {
          __typename?: 'MyGiftImage'
          name: string
          formats: Array<number>
        }
      }>
      pageInfo: {
        __typename?: 'PageInfo'
        endCursor: any
        hasNextPage: boolean
      }
    }
  }
  teamo?: {
    __typename?: 'PublicTeamo'
    compatibility?: number | null
    surveyResult?: Array<{
      __typename?: 'TeamoPeculiarity'
      id: number
      points: number
      title: string
      description: string
    }> | null
  } | null
}

export const ForeignProfileFragmentDoc = gql`
  fragment ForeignProfile on PublicProfile {
    id
    name
    age
    gender
    zodiacSign
    isBirthdayToday
    online {
      status
    }
    location {
      city {
        id
        name
      }
      region {
        id
        name
      }
      country {
        id
        name
      }
      name
    }
    verification {
      verifiedPhotos
    }
    relations {
      contact @include(if: $authorized) {
        contactId
        favorite
        ignoredByThem
      }
      spaceTimeLocation {
        text
      }
      distance {
        text
      }
      winkedByMe @include(if: $authorized)
    }
    ...Photos
    incognito
    deleted
    ...TravelAtlas
    ...Vip
    ...Dating
    ...Interests
    ...Gifts
    ...TeamoTest
    compatibility @include(if: $authorized)
  }
  ${PhotosFragmentDoc}
  ${TravelAtlasFragmentDoc}
  ${VipFragmentDoc}
  ${DatingFragmentDoc}
  ${InterestsFragmentDoc}
  ${GiftsFragmentDoc}
  ${TeamoTestFragmentDoc}
`
export const ForeignParamsFragmentDoc = gql`
  fragment ForeignParams on Query {
    user(userId: $userId, hitType: $hitType) {
      ...ForeignProfile
    }
  }
  ${ForeignProfileFragmentDoc}
`
